/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { CollectionView, SortDescription } from "@grapecity/wijmo";
import { cloneDeep } from "lodash";

import apiClient from "../../lib/common/apiClient";

function GetListApi ( props ) {

    const { t } = useTranslation();

    const {

        $filter,
        $orderBy,
        $start,
        $length,
        $search,
        $queries,
        table,
        onModifyUrl,
        onCountChange,
        onLoadData,
        onSuccess,
        onFailure,
        children,
        onInitialized,
        useTable,
        makeEmptyRow,
        collectionViewChange,

    } = props;

    const [data, setData] = useState();
    // 가장 최근 조건으로 읽는 손잡이 — 화면이 예전 조건 때 받은 refresh 를 들고 있어도 지금 조건으로 다시 읽는다
    const latest = useRef();
    // 마지막으로 보낸 읽기의 번호 — 조건이 바뀌기 전에 보낸 읽기가 늦게 와 새 목록을 덮지 않게 마지막 응답만 쓴다(견적 관리 버전 목록이 빈 채로 남던 일)
    const lastRequest = useRef(0);
    // 조건을 바꿔 보낸 읽기가 아직 오지 않았는가 — 그 사이 refresh 가 그 읽기를 대신하면(목록 손잡이를 받자마자 refresh 하는 화면) 조건을 바꾼 읽기로 본다
    const searching = useRef(false);
    // 화면이 URL 로 넘기는 조건(보고서 기간 등)을 사용자가 바꿔 다시 읽는가(search) — 검색어 · 필터가 없어도 비면 알린다
    const conditionChanged = useRef(false);
    const [collectionView, setCollectionView] = useState();

    const [, setModifyUrl] = useState();

    useEffect ( () => {

        setModifyUrl ( () => ( url ) => {

            if (onModifyUrl) {

                return onModifyUrl(url);

            } else {

                return url;

            }

        });

    }, [onModifyUrl] );

    const buildQuery = ( props ) => {

        let first = true;
        let queryString = "";

        for ( const name in props ) {

            if ( name === "$queries" ) {

                continue;

            }

            if ( ! first ) {

                queryString += "&";

            }

            if ( props[name] === "" || props[name] === undefined || props[name] === null ) {

                continue;

            }

            first = false;

            queryString += name + "=" + props[name];

        }

        if ( props && props["$queries"] ) {

            let queries = props["$queries"];

            for ( const name in queries ) {

                if ( ! first ) {

                    queryString += "&";

                }

                if ( queries[name] === "" || queries[name] === undefined || queries[name] === null ) {

                    continue;

                }

                first = false;

                queryString += name + "=" + queries[name];

            }
        }

        return queryString;

    };

    const getData = ( query, mountStatus, isRefresh, isSearch ) => {
        
        setModifyUrl ( ( modifyUrl ) => {

            if ( query.length > 0 ) {

                query = "?" + query;

            }

            let url = "/api/" + table;

            if ( modifyUrl ) {

                url = modifyUrl ( url ) + query;

            } else {

                url += query;

            }

            if ( ! table ) {

                return;

            }

            const request = ++lastRequest.current;
            const searched = ( searching.current = ! isRefresh || searching.current );
            const changed = ( conditionChanged.current = !! isSearch || ( !! isRefresh && conditionChanged.current ) );

            apiClient
                .get( url )
                .then( ( response ) => {

                    if  ( mountStatus.isMounted && request === lastRequest.current ) {

                        searching.current = false;
                        conditionChanged.current = false;

                        if ( onSuccess ) {

                            onSuccess ( response );

                        }
    
                        if ( onCountChange ) {

                            onCountChange ( response.data.filtered );

                        }
    
                        if ( children ) {
    
                            if ( onLoadData ) {

                                onLoadData ( response.data.data );

                            }
    
                            if ( useTable ) {
    
                                let data = cloneDeep ( response.data.data );
    
                                if ( makeEmptyRow ) {
    
                                    if ( data.length < $length ) {
    
                                        let emptyCount = $length - data.length;
    
                                        for ( let i = 0; i < emptyCount; i++ ) {
    
                                            data.push ( makeEmptyRow ( i ) );
    
                                        }
                                    }
    
                                }
    
                                setData ( data );
    
                            } else {
    
                                let collectionView = new CollectionView ( response.data.data );
                                let orderBy = JSON.parse ( $orderBy );
        
                                for ( const sortOrder of orderBy ) {

                                    let sortDescription = new SortDescription ( sortOrder.column, sortOrder.order === "ASC" );
                                    collectionView.sortDescriptions.push ( sortDescription );

                                }

                                if (collectionViewChange) {

                                    collectionViewChange(collectionView)

                                }
                                
                                setCollectionView ( collectionView );
        
                            }
    
                        }

                        try {

                            // 저장 · 삭제 · 처리 뒤 다시 읽기(refresh)로 빈 것은 알리지 않는다 — 사용자가 조건을 바꿔 찾은 때만 알린다
                            if ( searched && ( changed || JSON.parse ( $filter ).length > 0 || $search ) ) {

                                if ( response.data.data.length === 0 ) {
    
                                    if ( onFailure ) {
    
                                        onFailure ( t( "infoMsg.noData" ) );
                                    }
    
                                }
                            }
    
                        } catch ( reason ) {

                            // Do nothing

                        }

                    }

                } )
                .catch ( ( reason ) => {

                    if ( request === lastRequest.current ) {

                        searching.current = false;
                        conditionChanged.current = false;

                    }

                    if ( mountStatus.isMounted && request === lastRequest.current && onFailure ) {

                        onFailure ( reason );

                    }
                    
                } );

            return modifyUrl;

        } );

    };

    useEffect ( () => {

        let mountStatus = {
            isMounted: true,
        };

        let myInstance = {

            refresh: () => {

                latest.current.getData ( latest.current.query, latest.current.mountStatus, true );

            },

            // 사용자가 화면 조건(보고서 기간 등)을 바꿔 다시 읽는다 — 결과가 비면 「데이터가 없습니다」를 알린다
            search: () => {

                latest.current.getData ( latest.current.query, latest.current.mountStatus, false, true );

            },

        };

        let query = buildQuery ( {

            $filter,
            $orderBy,
            $start,
            $length,
            $search,
            $queries,

        } );

        latest.current = { getData, query, mountStatus };

        getData ( query, mountStatus );

        if ( onInitialized ) {

            onInitialized ( myInstance );

        }

        return ( () => {

            mountStatus.isMounted = false;

        } );

    }, [ $filter, $orderBy, $start, $length, $search, $queries ] );

    return (
        
        <>
            {

                children
                ?
                (
                    React.Children.map ( children, ( child ) =>
                        React.isValidElement ( child )
                        ?
                        React.cloneElement (

                            child,

                            {

                                itemsSource: collectionView,
                                data: data,

                            }

                        )
                        :
                        child
                    )
                )
                : 
                <></>

            }
        </>

    );

}

export default GetListApi;
